import { render, staticRenderFns } from "./_newTaskModal.vue?vue&type=template&id=068d88b2"
import script from "./_newTaskModal.vue?vue&type=script&lang=js"
export * from "./_newTaskModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports